//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from 'vuex';
import GetReport from '~/components/GetReport.vue';
import constant from '~/const';

export default {

  components: {
    GetReport,
  },
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      constant,
      filters: {
        searchString: '',
        userId: '',
        buyerCurrency: undefined,
        sellerCurrency: undefined,
        requisiteId: undefined,
        dateFrom: '',
        dateTo: '',
        requisites: undefined,
        status: undefined,
      },
    };
  },

  computed: {
    ...mapState('tradersDeals', ['filterLists']),

    ...mapState('tradersRequisites', { requisites: 'data' }),

    ...mapState('tradersCurrencies', { currencies: 'data' }),

    ...mapState('tradersPaymentMethods', { paymentMethods: 'data' }),

    ...mapGetters('tradersDeals', { getReportData: 'reportData' }),

    reportOperations: () => constant.reports.P2PAY_REPORT_TYPE_IDS.TRADES,

    getStatuses() {
      return Object.keys(constant.traders.TRADE_STATUS_IOTA).map((key) => ({
        id: parseInt(key, 10),
        name: constant.traders.TRADE_STATUS_IOTA[key],
      }));
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  mounted() {
    const { search } = this.$route.query;

    if (search) {
      this.$router.replace({ query: {} });
      this.filters = {
        ...this.filters,
        searchString: search,
      };
    } else {
      this.loadData();
    }
  },

  methods: {
    ...mapActions('tradersDeals', ['setFilters', 'loadData']),
  },
};
